<template>
  <div>
    <div class="grid gap-4 py-6 border-t bg-gray-50 md:grid-cols-3 auto-rows-auto lg:grid-cols-5">
      <DatePicker class="col-span-2" color="indigo" mode="dateTime" :minute-increment="5" is-range is24hr v-model="filter.date" :model-config="{ start: { timeAdjust: '00:00:00' }, end: { timeAdjust: '23:59:59' } }">
        <template v-slot="{ inputValue, inputEvents }">
          <div class="flex justify-center">
            <input
              :value="inputValue.start"
              v-on="inputEvents.start"
              class="w-40 form-input prepend"
            />
            <div class="flex items-center justify-center flex-none w-10 border bg-gray-50">
              &rarr;
            </div>
            <input
              :value="inputValue.end"
              v-on="inputEvents.end"
              class="w-40 form-input append"
            />
          </div>
        </template>
      </DatePicker>
    </div>

    <template v-if="report">
      <div class="card">
        <div class="flex flex-col">
          <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
              <div class="overflow-hidden">
                <table class="min-w-full divide-y divide-gray-100">
                  <thead>
                    <tr class="border-t border-b">
                      <th class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase bg-gray-50">
                        Vehicle
                      </th>
                      <th v-for="period in report.rows[0].periods" :key="period.label" class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-right text-gray-500 uppercase bg-gray-50">
                        {{ period.label }}
                      </th>
                    </tr>
                  </thead>
                  <tbody class="divide-y">
                    <tr class="bg-white group" v-for="row in report.rows" :key="row.orderid">
                      <td class="px-6 py-4 text-sm font-medium leading-5 text-gray-900 whitespace-nowrap group-hover:bg-gray-50">
                        {{ row.vehicle }}
                      </td>
                      <td v-for="period in row.periods" :key="period.label" class="px-6 py-4 text-sm leading-5 text-right text-gray-900 whitespace-nowrap group-hover:bg-gray-50">
                        {{ $currency(period.value / 100, account.currency) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { sub, formatDuration } from 'date-fns'
import { mapGetters } from 'vuex'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'

export default {
  name: 'CPKReport',

  components: {
    DatePicker
  },

  props: {
    report: {
      type: Object
    }
  },

  computed: {
    ...mapGetters(['account']),
    
    params () {
      return { 
        filter: this.filter
      }
    }
  },

  data () {
    return {
      filter: {
        date: {
          start: sub(new Date(), { days: 30 }),
          end: new Date()
        }
      }
    }
  }
}
</script>